export default "__VITE_ASSET__1a1e1efc__"